import React from "react";
import { Modal } from "@nextui-org/react";

const Preview = ({ file, setFile }) => {

    const closeHandler = () => {
        setFile(null);
    };

    if (!file) return <></>;

    const id = file.drive_key;

    return (
        <Modal
            closeButton
            open={(file !== null && file)}
            onClose={closeHandler}
            className="preview card"
            scroll
        >
            <Modal.Header>
                <p style={{ fontSize: 18 }}>
                    {file.name}
                </p>
            </Modal.Header>
            <Modal.Body css={{ padding: 0}}>
                <iframe title="iframe" allow="autoplay" id="preview" src={`https://drive.google.com/file/d/${id}/preview`} />
            </Modal.Body>
            <Modal.Footer>
                <span>
                    <button>Partager</button>

                    <a target="_blank" rel="noopener noreferrer" href={`https://drive.google.com/file/d/${id}`}>
                        <button>Imprimer</button>
                    </a>

                    <a href={`https://drive.google.com/u/0/uc?id=${id}&export=download`}>
                        <button className="second">Télécharger</button>
                    </a>
                </span>

            </Modal.Footer>
        </Modal>
    )
}

export default Preview;